import { Box, CircularProgress } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './auth-context';

/** Route guard for /admin/*. Preserves the intended destination across login. */
export function RequireAuth() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100dvh' }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (!user) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  return <Outlet />;
}
